import React, { useState } from 'react';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import logo from '../assets/logo-w.png';

function ContactForm() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!executeRecaptcha) {
      setStatus({ type: 'error', message: 'Recaptcha not yet available' });
      return;
    }

    setSending(true);
    setStatus({ type: '', message: '' });

    try {
      const token = await executeRecaptcha('contact_form');

      const response = await fetch('https://www.techowdy.com/send-mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...formData, captcha: token })
      });

      const result = await response.json();

      if (result.success) {
        setStatus({ type: 'success', message: '✅ Thank you! Your message has been sent successfully.' });
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        setStatus({ type: 'error', message: result.message || '❌ Something went wrong. Please try again.' });
      }
    } catch (error) {
      setStatus({ type: 'error', message: '❌ Server error. Please try again later.' });
    } finally {
      setSending(false);
    }
  };


  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="contact-header">
          <div className="section-label">GET STARTED TODAY</div>
          <h2 className="contact-title">Ready to Grow Your Business?</h2>
          <p className="contact-subtitle">
            Get a free consultation and quote. No obligation. Fast turnaround. 100% satisfaction guaranteed.
          </p>
          <div className="contact-quick-cta">
            <a href="tel:+16893091235" className="quick-cta-btn phone-cta">
              📞 Call Now: +1 (689) 309-1235
            </a>
            <span className="cta-or">or</span>
            <span className="quick-cta-text">Fill out the form below</span>
          </div>
        </div>

        <div className="contact-grid">
          <div className="contact-info-modern">
            <div className="info-block">
              <div className="info-label">Email</div>
              <a href="mailto:hello@techowdy.com" className="info-link">hello@techowdy.com</a>
            </div>
            <div className="info-block">
              <div className="info-label">US</div>
              <a href="tel:+16893091235" className="info-link">+1 (689) 309-1235</a>
            </div>
            <div className="info-block">
              <div className="info-label">UK</div>
              <a href="tel:+447480415597" className="info-link">+44 7480 415597</a>
            </div>
            {/*<div className="info-block">
                          <div className="info-label">Location</div>
                          <div className="info-text">Kalispell, MT 59901</div>
                        </div>*/}
          </div>

          <form className="modern-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-input"
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-row">
              <input
                type="tel"
                name="phone"
                placeholder="Phone (Optional)"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
              />
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
                className="form-select"
              >
                <option value="">Select Service</option>
                <option value="laravel">Laravel</option>
                <option value="wordpress">WordPress</option>
                <option value="shopify">Shopify</option>
                <option value="wix">Wix</option>
                <option value="mobile">Mobile Apps</option>
                <option value="custom">Custom</option>
              </select>
            </div>

            <textarea
              name="message"
              placeholder="Tell us about your project"
              value={formData.message}
              onChange={handleChange}
              rows="6"
              required
              className="form-textarea"
            ></textarea>

            <button type="submit" className="btn-submit-large" disabled={sending}>
              {sending ? 'Sending...' : 'Send Message →'}
            </button>

            {status.message && (
              <p
                className={`form-status ${
                  status.type === 'success' ? 'success-text' : 'error-text'
                }`}
                style={{
                  marginTop: '12px',
                  textAlign: 'center',
                  color: status.type === 'success' ? '#28a745' : '#dc3545',
                  fontWeight: 500
                }}
              >
                {status.message}
              </p>
            )}
          </form>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <img src={logo} alt="Techowdy LLC" className="footer-logo" />
          </div>
          <div className="footer-text">© 2025 Techowdy LLC. All rights reserved.</div>
        </div>
      </footer>
    </section>
  );
}

export default function Contact() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LdJiCwrAAAAAKuH5Xm0gt5B6rO5YoyCAw1vKGXN">
      <ContactForm />
    </GoogleReCaptchaProvider>
  );
}